import { Store } from '@sama/app-state';
import { combineLatest } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import {
  Tag,
  TagsState,
} from '../../../../cross-team-shared/annotation/shared/state/shape-state';
import { ensureKeyDynamicTag } from '../../../../cross-team-shared/annotation/shared/utils/keyframe-utils';
import { getDynamicTag } from '../../../../cross-team-shared/misc-services/tag-helper';
import { Attribute } from '../../../../team-apis/otterdam/taxonomy';

export function getAttributeValue$(
  attribute: Attribute,
  tagsStore: Store<TagsState>,
  frameNumberStore: Store<number>,
) {
  if (attribute.isDynamic) {
    return combineLatest([
      tagsStore('dynamic_tags')(attribute.name).$,
      frameNumberStore.$,
    ]).pipe(
      filter(() => !!tagsStore.state()),
      map(([frameSpecificTags, frameNumber]) =>
        getDynamicTag(frameSpecificTags, frameNumber),
      ),
      distinctUntilChanged(),
    );
  } else {
    return tagsStore('tags')(attribute.name).$.pipe(
      filter(() => !!tagsStore.state()),
    );
  }
}

export function getAttributeValue(
  attribute: Attribute,
  tagsStore: Store<TagsState>,
  frameNumber: number,
) {
  if (attribute.isDynamic) {
    return getDynamicTag(
      tagsStore.state().dynamic_tags[attribute.name],
      frameNumber,
    );
  }
  return tagsStore.state().tags[attribute.name];
}

export function setAttribute(
  tagsStore: Store<TagsState>,
  attribute: Attribute,
  value: Tag,
  frameNumber: number,
) {
  if (attribute.isDynamic) {
    ensureKeyDynamicTag(tagsStore, attribute.name, {
      frame_number: frameNumber,
      value,
    });
  } else {
    tagsStore('tags')(attribute.name).set(value);
  }
}
